<template>
    <div>
        <PWAPrompt />
        <v-container v-if="isFirefox" fluid>
           <v-row>
               <v-col>
                   <v-alert  type="warning">
                       <b>Firefox Detected:</b> For the best experience with CFMA eReader, please use <a target="_blank" href="https://www.google.com/chrome/">Chrome</a> instead of Firefox.
                   </v-alert>
               </v-col>
           </v-row>
        </v-container>
        <MessageBar />
        <Books :checkOnline="isConnected" />
    </div>
</template>

<script>
import MessageBar from "@/components/MessageBar.vue";
import PWAPrompt from "@/components/PWAPrompt.vue";
import Books from "@/components/Books.vue";
import { mapState } from "vuex";

export default {
    data() {
        return {
            hasLoaded: false,
            isFirefox: navigator.userAgent.toLowerCase().indexOf('firefox') > -1
        };
    },
    name: "Ereader",
    components: {
        PWAPrompt,
        MessageBar,
        Books,
    },
    methods: {},
    computed: {
        ...mapState({ isConnected: "isOnline" }),
    },
    mounted() {
        this.hasLoaded = true;
    },
};
</script>
<style scoped src="../assets/scss/main.css"></style>
